// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2Cbvd","right":"Footer_right__WLPaY","buttons":"Footer_buttons__3wwTu"};